import React from 'react';
import { useHistory } from 'react-router';
import PopDialog from 'component/LHH/PopDialog/PopDialog';
import { ButtonOutline, } from 'component/material/ButtonContained/Button';
var ExpireNotice = function (props) {
    var open = props.open, onClose = props.onClose, resetTimer = props.resetTimer;
    var history = useHistory();
    // 登出：清掉 session 後導回登入頁
    var handleRelogin = function () {
        var loginPage = window.sessionStorage.getItem('loginPage') || '/login';
        window.sessionStorage.clear();
        onClose();
        history.push(loginPage);
    };
    return (React.createElement(PopDialog, { show: open, title: "\u7CFB\u7D71\u8A0A\u606F", width: "30vw", handleExit: handleRelogin },
        React.createElement("div", { style: { padding: '8px 4px', lineHeight: 1.8 } }, "\u7531\u65BC\u60A8\u5DF2\u9023\u7DDA30\u5206\u9418\uFF0C\u70BA\u4E86\u4FDD\u8B77\u60A8\u7684\u5E33\u6236\u5B89\u5168\uFF0C\u8ACB\u9EDE\u64CA\u4E0B\u65B9\u6309\u9215\u91CD\u65B0\u9023\u7DDA\u6216\u8ACB\u91CD\u65B0\u767B\u5165\u4EE5\u7E7C\u7E8C\u64CD\u4F5C\u3002"),
        React.createElement("div", { style: {
                display: 'flex',
                justifyContent: 'center',
                marginTop: '16px',
            } },
            React.createElement(ButtonOutline, { onClick: handleRelogin }, "\u91CD\u65B0\u767B\u5165"))));
};
export default ExpireNotice;
